import { diseaseModalQueryBuilder } from '@/components/modals/DiseaseModal';

export const diseasesForResearchPlatformQuery = diseaseModalQueryBuilder
  .filter(
    `references(*[_type == "researchPlatform" && select(defined($slug) => slug.current == $slug, defined($id) => _id == $id, false)]._id)`
  )
  .use();
